// Shared by both forks.
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../abilities/Can';

export function useSpotlightCapabilities() {
	const ability = useAbility(AbilityContext);

	const canShowStickySearch = ability.can('show', 'sticky_search');
	const canShowRecentSearches = ability.can('show', 'spotlight_recent_searches');
	const canShowBrandguidelines =
		ability.can('show', 'brandguidelines') || ability.can('show', 'homepage');

	return { canShowStickySearch, canShowRecentSearches, canShowBrandguidelines };
}
